"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepFreeze = void 0;
/**
 * Recursively freeze the object and all nested objects.
 *
 * via https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze#examples
 */
const deepFreeze = (objectToFreeze) => {
    const propNames = Reflect.ownKeys(objectToFreeze);
    for (const name of propNames) {
        const value = objectToFreeze[name];
        if ((value && typeof value === 'object') || typeof value === 'function') {
            (0, exports.deepFreeze)(value);
        }
    }
    return Object.freeze(objectToFreeze);
};
exports.deepFreeze = deepFreeze;
//# sourceMappingURL=object.js.map